import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { MarkNotificationAsSeenRequestDto } from '@/api/generated';
import { QueryKeyEnum } from '@/api/model/QueryKey.enum.ts';
import { useApiClient } from '@/api/useApiClient.util';

type Req = {
  markNotificationAsSeenRequestDto: MarkNotificationAsSeenRequestDto;
  notificationId: number;
};

type Return = {
  isSettingNotificationAsUnseen: boolean;
  setNotificationAsUnseen: (req: Req) => Promise<void>;
};

export const useSetNotificationAsUnseen = (): Return => {
  const { restNotificationControllerApi } = useApiClient();
  const queryClient = useQueryClient();

  const { isPending, mutateAsync } = useMutation<void, AxiosError, Req>({
    mutationFn: async req => {
      await restNotificationControllerApi.markNotificationAsNotSeen(
        req.notificationId,
        req.markNotificationAsSeenRequestDto,
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        queryKey: [QueryKeyEnum.NOTIFICATIONS],
      });
    },
  });

  return {
    isSettingNotificationAsUnseen: isPending,
    setNotificationAsUnseen: mutateAsync,
  };
};
